import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  ModalFooter,
  Label,
  Table,
} from "reactstrap";
// core components
import Header from "components/Headers/Header";

const RecordOrderPackage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const role = (
    user?.role ||
    localStorage.getItem("role") ||
    "user"
  ).toLowerCase();

  // state ฟอร์มอย่างง่าย
  const [form, setForm] = useState({
    zoneId: "", // <- เก็บโซน
  });

  const cusTypeOptions = [
    {
      value: "002",
      label: "กางเกง",
    },
    {
      value: "003",
      label: "เสื้อ",
    },
  ];

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  // เพิ่มใต้ useState(form) เดิม
  const [detailName, setDetailName] = useState(""); // สินค้าที่เลือก
  const [detailQty, setDetailQty] = useState(""); // จำนวน
  const [details, setDetails] = useState([]); // รายการทั้งหมด
  const [dateFrom, setDateFrom] = useState("");
  const [showInlineEditor, setShowInlineEditor] = useState(false);

  const handleAddDetail = () => {
    const qty = Number(detailQty);
    if (!detailName) return alert("กรุณาเลือกสินค้า");
    if (!qty || qty <= 0) return alert("กรุณากรอกจำนวนให้ถูกต้อง");

    const product = cusTypeOptions.find((o) => o.value === detailName);
    setDetails((prev) => [
      ...prev,
      {
        id: Date.now(), // key ชั่วคราว
        productValue: detailName, // "002"
        productLabel: product?.label, // "กางเกง" / "เสื้อ"
        qty,
      },
    ]);

    // เคลียร์ฟอร์มย่อย
    setDetailName("");
    setDetailQty("");
  };

  const handleRemoveDetail = (id) => {
    setDetails((prev) => prev.filter((d) => d.id !== id));
  };

  const handleChangeDetailQty = (id, value) => {
    const qty = Number(value);
    setDetails((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, qty: isNaN(qty) ? "" : qty } : item
      )
    );
  };

  const handleCancelPackageCustomer = () => {
    navigate("/order-orgs");
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col xs="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h6 className="mb-0">เปิดบิล</h6>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">
                    ข้อมูลส่วนหัว
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="2">
                        <FormGroup>
                          <div className="d-flex align-items-center">
                            <label
                              className="form-control-label mb-0"
                              style={{
                                width: "auto",
                                marginRight: 4,
                                color: "#475569",
                                fontWeight: 600,
                              }}
                            >
                              รหัสลูกค้า:
                            </label>
                            <span
                              className="text-dark font-weight-bold"
                              style={{ marginLeft: 4 }}
                            >
                              0001
                            </span>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg="2">
                        <FormGroup>
                          <div className="d-flex align-items-center">
                            <label
                              className="form-control-label mb-0"
                              style={{
                                width: "auto",
                                marginRight: 4,
                                color: "#475569",
                                fontWeight: 600,
                              }}
                            >
                              ชื่อลูกค้า:
                            </label>
                            <span
                              className="text-dark font-weight-bold"
                              style={{ marginLeft: 4 }}
                            >
                              ลูกค้า 1
                            </span>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg="3" md="4" sm="6">
                        <FormGroup>
                          <div className="d-flex align-items-center">
                            <label
                              className="form-control-label mb-0"
                              style={{
                                width: "auto",
                                marginRight: 4,
                                color: "#475569",
                                fontWeight: 600,
                              }}
                            >
                              เลขที่แพ็คเกจ:
                            </label>
                            <span
                              className="text-dark font-weight-bold"
                              style={{ marginLeft: 4 }}
                            >
                              250013
                            </span>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg="3" md="4" sm="6">
                        <FormGroup>
                          <div className="d-flex align-items-center">
                            <label
                              className="form-control-label mb-0"
                              style={{
                                width: "auto",
                                marginRight: 4,
                                color: "#475569",
                                fontWeight: 600,
                              }}
                            >
                              แพ็คเกจ:
                            </label>
                            <span
                              className="text-dark font-weight-bold"
                              style={{ marginLeft: 4 }}
                            >
                              ซักอบรีด(เครื่อง)
                            </span>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="2">
                        <FormGroup>
                          <div className="d-flex align-items-center">
                            <label
                              className="form-control-label mb-0"
                              style={{
                                width: "auto",
                                marginRight: 4,
                                color: "#475569",
                                fontWeight: 600,
                              }}
                            >
                              คงเหลือ:
                            </label>
                            <span
                              className="text-dark font-weight-bold"
                              style={{ marginLeft: 4 }}
                            >
                              40 ชิ้น
                            </span>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg="2">
                        <FormGroup>
                          <div className="d-flex align-items-center">
                            <label
                              className="form-control-label mb-0"
                              style={{
                                width: "auto",
                                marginRight: 4,
                                color: "#475569",
                                fontWeight: 600,
                              }}
                            >
                              หมดอายุ:
                            </label>
                            <span
                              className="text-dark font-weight-bold"
                              style={{ marginLeft: 4 }}
                            >
                              2025-10-10
                            </span>
                          </div>
                        </FormGroup>
                      </Col>

                      <Col lg="3" md="4" sm="6">
                        <FormGroup className="mb-2">
                          <div
                            className="d-flex align-items-center"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            <label
                              className="form-control-label mb-0"
                              style={{
                                marginRight: 8,
                                color: "#475569",
                                fontWeight: 600,
                                flexShrink: 0,
                              }}
                            >
                              วันที่รับผ้า:
                            </label>
                            <Input
                              type="date"
                              bsSize="sm"
                              className="form-control-alternative"
                              value={dateFrom}
                              onChange={(e) => setDateFrom(e.target.value)}
                              style={{ width: 200, flexShrink: 0 }}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg="3" md="4" sm="6">
                        <FormGroup>
                          <div className="d-flex align-items-center">
                            <label
                              className="form-control-label mb-0"
                              style={{
                                width: "auto",
                                marginRight: 4,
                                color: "#475569",
                                fontWeight: 600,
                              }}
                            >
                              วันที่ส่งผ้า:
                            </label>
                            <Input
                              type="date"
                              bsSize="sm"
                              className="form-control-alternative"
                              value={dateFrom}
                              onChange={(e) => setDateFrom(e.target.value)}
                              style={{ width: 200, flexShrink: 0 }}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-3" />
                  <h6 className="heading-small text-muted mb-4">รายละเอียด</h6>
                  <Row>
                    <Col lg="4">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-qty"
                        >
                          สินค้า
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="select"
                          name="detailName"
                          value={detailName}
                          onChange={(e) => setDetailName(e.target.value)}
                        >
                          <option value="">-- เลือก --</option>
                          {cusTypeOptions.map((o) => (
                            <option key={o.value} value={o.value}>
                              {o.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col lg="4">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-qty"
                        >
                          จำนวน
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-qty"
                          type="number"
                          min="1"
                          value={detailQty}
                          onChange={(e) => setDetailQty(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup className="mb-0">
                        <Label className="invisible">offset</Label>{" "}
                        {/* ดันความสูงเท่า label */}
                        <Button
                          color="info"
                          onClick={handleAddDetail}
                          className="w-100 mb-5"
                        >
                          เพิ่มรายละเอียด
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <div className="table-responsive">
                        <Table
                          responsive
                          hover
                          borderless
                          className="table  table-modern mb-0"
                        >
                          <colgroup>
                            <col style={{ width: "30%" }} />
                            <col style={{ width: "20%" }} />
                            <col style={{ width: "10%" }} />
                          </colgroup>
                          <thead className="thead-colored">
                            <tr>
                              <th style={{ width: "60%" }}>สินค้า</th>
                              <th
                                className="text-center"
                                style={{ width: "20%" }}
                              >
                                จำนวน
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "20%" }}
                              >
                                ลบ
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {details.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={3}
                                  className="text-center text-muted"
                                >
                                  ยังไม่มีรายการ
                                </td>
                              </tr>
                            ) : (
                              details.map((d) => (
                                <tr key={d.id}>
                                  <td>
                                    <Input
                                      type="text"
                                      value={d.productLabel || ""}
                                      readOnly
                                      className="bg-light"
                                    />
                                  </td>
                                  <td className="text-center">
                                    <Input
                                      type="number"
                                      min="0"
                                      value={d.qty}
                                      onChange={(e) =>
                                        handleChangeDetailQty(
                                          d.id,
                                          e.target.value
                                        )
                                      }
                                      className="form-control-alternative"
                                      style={{
                                        maxWidth: 120,
                                        margin: "0 auto",
                                        textAlign: "center",
                                      }}
                                    />
                                  </td>
                                  <td className="text-center">
                                    <Button color="danger">ลบ</Button>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                  <hr className="my-4" />
                  <Row>
                    <Col lg="4">
                      <img
                        style={{
                          width: "100px",
                          height: "100px",
                          marginBottom: "10px",
                        }}
                        src={require("../../assets/img/theme/hanger.png")}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="4">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-qty"
                        >
                          ไม้แขวน
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-qty"
                          type="number"
                          min="1"
                          value={detailQty}
                          onChange={(e) => setDetailQty(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="8">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-qty"
                        >
                          หมายเหตุ
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-qty"
                          type="number"
                          min="1"
                          value={detailQty}
                          onChange={(e) => setDetailQty(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancelPackageCustomer}>
          ยกเลิก
        </Button>
        <Button color="primary" type="submit">
          บันทึก
        </Button>
      </ModalFooter>
    </>
  );
};

export default RecordOrderPackage;
